<div class="wrapper-contact-page">
    <!-- Contanct page -->
  <div class="zc-container-fluid">
    <div class="zc-container">
      <div class="grid">
        <div class="grid__l-6">
          <div class="wrapper-left-contact">
            <h1>Kontaktirajte nas</h1>
            <p>Imate pitanje ili želite da registrujete svoj biznis? Slobodno nas kontaktirajte — naš tim je tu da vam pomogne.</p>
            <img src="../../../../assets/images/landing/illustration-contact.svg" alt="">
          </div>
        </div>
        <form [formGroup]="contactForm" (ngSubmit)="onSubmitContactForm()" class="grid__l-6">
          <div class="wrapper-right-contact">
            <div class="wrapper-input-landing" [ngClass]="{'error': contactForm.controls.name | formControlErrorMessages: null : formTriedToSubmit}">
              <span class="label-info-input">Ime i prezime</span>
              <div class="custom-input">
                <input [formControl]="contactForm.controls.name | formControl" type="text" placeholder="">
              </div>
              <span class="error-message">{{contactForm.controls.name | formControlErrorMessages: null : formTriedToSubmit}}</span>
            </div>
            <div class="wrapper-input-landing" [ngClass]="{'error': contactForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : formTriedToSubmit}">
              <span class="label-info-input">Email</span>
              <div class="custom-input">
                <input [formControl]="contactForm.controls.email | formControl" type="text" placeholder="">
              </div>
              <span class="error-message">{{contactForm.controls.email | formControlErrorMessages: 'Unesite validnu email adresu.' : formTriedToSubmit}}</span>
            </div>
            <div class="wrapper-custom-dropdown-landing" [ngClass]="{'error': contactForm.controls.category | formControlErrorMessages: null : formTriedToSubmit}">
              <span class="label-info-dropdown">Koja vas usluga zanima?</span>
              <div (click)="isDropdownOpen = !isDropdownOpen" class="custom-dropdown-landing" [ngClass]="{'open-dropdown': isDropdownOpen}">
                <span>{{selectedService ? selectedService.name : 'Odaberi uslugu'}}</span>
                <img src="../../../../assets/icons/landing/down-arrow-dropdown.svg" alt="">
                <div class="content-dropdown-landing">
                  <div *ngFor="let service of LandingBusinessCategories" (click)="onSelectService(service)" class="item-dropdown-landing">
                    <span>{{ service.name }}</span>
                    <img src="../../../../assets/icons/landing/icon-star-header.svg" alt="">
                  </div>
                </div>
              </div>
            </div>
            <span class="error-message">{{contactForm.controls.category | formControlErrorMessages: null : formTriedToSubmit}}</span>
            <div class="wrapper-textarea-landing" [ngClass]="{'error': contactForm.controls.message | formControlErrorMessages: null : formTriedToSubmit}">
              <span class="title-form-landing">Poruka</span>
              <div class="custom-textarea">
                <textarea [formControl]="contactForm.controls.message | formControl" type="text" placeholder=""></textarea>
              </div>
              <span class="error-message">{{contactForm.controls.message | formControlErrorMessages: null : formTriedToSubmit}}</span>
            </div>
            <span class="title-form-landing">Obraćate nam se kao</span>
            <div class="wrapper-custom-radiobutton-landing">
              <label>
                <input type="radio" name="user_type" formControlName="user_type" [value]="UserRole.user">
                <div class="custom-radiobutton">
                  <div class="circle-radio">
                    <div class="circle-center"></div>
                  </div>
                  <span>Fizičko lice</span>
                </div>
              </label>
              <label>
                <input type="radio" name="user_type" formControlName="user_type" [value]="UserRole.business">
                <div class="custom-radiobutton">
                  <div class="circle-radio">
                    <div class="circle-center"></div>
                  </div>
                  <span>Pravno lice</span>
                </div>
              </label>
            </div>
            <div *ngIf="contactForm.controls.user_type.value === UserRole.business" class="wrapper-input-landing" [ngClass]="{'error': contactForm.controls.pib | formControlErrorMessages: 'Unesite validan PIB broj.' : formTriedToSubmit}">
              <span class="label-info-input">PIB</span>
              <div class="custom-input">
                <input [formControl]="contactForm.controls.pib | formControl" type="text" placeholder="">
              </div>
              <span class="error-message">{{contactForm.controls.pib | formControlErrorMessages: 'Unesite validan PIB broj.' : formTriedToSubmit}}</span>
            </div>
            <button type="submit" class="custom-btn custom-btn--purple">
              <gr-loader *ngIf="isLoaderActive" [isButtonLoader]="true"></gr-loader>
              <span *ngIf="!isLoaderActive">Pošaljite</span>
              <img *ngIf="!isLoaderActive" src="../../../../assets/icons/landing/Icon-arrow-right.svg" alt="">
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
